import {
  DashboardOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  BookOutlined,
  TeamOutlined,
  AuditOutlined,
  ShoppingCartOutlined,
  BellOutlined,
  QuestionCircleOutlined,
  HistoryOutlined,
  CreditCardOutlined,
  GiftOutlined,
  TagsOutlined,
  AlertOutlined,
  ExceptionOutlined,
  ProfileOutlined,
  CalendarOutlined,
  GroupOutlined,
} from '@ant-design/icons';
import type { ReactNode } from 'react';

export interface MenuItem {
  key: string;
  path: string;
  name: string;
  icon?: ReactNode;
  /** 允许访问的 group 列表; 为空表示所有登录用户都可见 */
  groups?: string[];
  children?: MenuItem[];
}

/**
 * 顶层菜单按角色组过滤; LayoutWrapper 内会调 useAuthStore.hasAnyGroup() 过滤.
 *
 * 角色组定义:
 *   admin.superuser         — 全权
 *   admin.question_ops      — 题库/题组
 *   admin.paper_ops         — 试卷
 *   admin.exam_manager      — 考试场次 / 考生 / 监考
 *   admin.scorer            — 我的评分 / 评分争议
 *   admin.finance           — 订单 / 支付 / 优惠券
 *   admin.customer_service  — 用户 / 通知 / FAQ / 登录历史 / 行业
 */
export const MENU_ITEMS: MenuItem[] = [
  {
    key: 'dashboard',
    path: '/dashboard',
    name: '仪表盘',
    icon: <DashboardOutlined />,
  },

  // 题库 / 试卷 / 考试 (内容运营)
  {
    key: 'questions',
    path: '/questions',
    name: '题库管理',
    icon: <BookOutlined />,
    groups: ['admin.question_ops'],
  },
  {
    key: 'question-groups',
    path: '/question-groups',
    name: '题组管理',
    icon: <GroupOutlined />,
    groups: ['admin.question_ops'],
  },
  {
    key: 'exam-papers',
    path: '/exam-papers',
    name: '试卷管理',
    icon: <FileTextOutlined />,
    groups: ['admin.paper_ops'],
  },
  {
    key: 'exam-sessions',
    path: '/exam-sessions',
    name: '考试场次',
    icon: <CalendarOutlined />,
    groups: ['admin.exam_manager'],
  },
  {
    key: 'exam-participants',
    path: '/exam-participants',
    name: '考生记录',
    icon: <ProfileOutlined />,
    groups: ['admin.exam_manager'],
  },
  {
    key: 'proctor',
    path: '/proctor',
    name: '监考日志',
    icon: <AlertOutlined />,
    groups: ['admin.exam_manager'],
  },

  // 评分
  {
    key: 'scoring',
    path: '/scoring',
    name: '评分记录',
    icon: <AuditOutlined />,
    groups: ['admin.scorer'],
  },
  {
    key: 'scoring-disputes',
    path: '/scoring-disputes',
    name: '评分争议',
    icon: <ExceptionOutlined />,
    groups: ['admin.scorer'],
  },

  // 订单 / 支付 / 优惠券
  {
    key: 'orders',
    path: '/orders',
    name: '订单管理',
    icon: <ShoppingCartOutlined />,
    groups: ['admin.finance'],
  },
  {
    key: 'payments',
    path: '/payments',
    name: '支付记录',
    icon: <CreditCardOutlined />,
    groups: ['admin.finance'],
  },
  {
    key: 'coupons',
    path: '/coupons',
    name: '优惠券',
    icon: <GiftOutlined />,
    groups: ['admin.finance'],
  },
  {
    key: 'products',
    path: '/products',
    name: '产品目录',
    icon: <TagsOutlined />,
    groups: ['admin.finance'],
  },

  // 用户与基础数据 (客服)
  {
    key: 'users',
    path: '/users',
    name: '用户管理',
    icon: <TeamOutlined />,
    groups: ['admin.customer_service'],
  },
  {
    key: 'industries',
    path: '/industries',
    name: '行业管理',
    icon: <AppstoreOutlined />,
    groups: ['admin.customer_service'],
  },
  {
    key: 'notifications',
    path: '/notifications',
    name: '通知管理',
    icon: <BellOutlined />,
    groups: ['admin.customer_service'],
  },
  {
    key: 'faq',
    path: '/faq',
    name: 'FAQ',
    icon: <QuestionCircleOutlined />,
    groups: ['admin.customer_service'],
  },
  {
    key: 'login-history',
    path: '/login-history',
    name: '登录历史',
    icon: <HistoryOutlined />,
    groups: ['admin.customer_service'],
  },
];
